var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-container"},[_c('div',{ref:"stream",staticClass:"stream",class:_vm.rotateClass,attrs:{"id":"stream"}}),(_vm.attentionInfo)?_c('div',{staticClass:"tip-container"},[_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.attentionInfo))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }